import React, { createContext, useContext, useState, useEffect } from 'react';

// Create context
const LanguageContext = createContext();

// Available languages
export const AVAILABLE_LANGUAGES = [
  { code: 'am', name: 'አማርኛ', flag: '🇪🇹' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'gez', name: 'ግዕዝ', flag: '🇪🇹' }
];

// Default language
const DEFAULT_LANGUAGE = 'am';

// Provider component
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(DEFAULT_LANGUAGE);

  // Load language preference from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && AVAILABLE_LANGUAGES.find(lang => lang.code === savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  // Save language preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('preferredLanguage', currentLanguage);
  }, [currentLanguage]);

  // Change language function
  const changeLanguage = (languageCode) => {
    if (AVAILABLE_LANGUAGES.find(lang => lang.code === languageCode)) {
      setCurrentLanguage(languageCode);
    }
  };

  // Get current language info
  const getCurrentLanguageInfo = () => {
    return AVAILABLE_LANGUAGES.find(lang => lang.code === currentLanguage) || AVAILABLE_LANGUAGES[0];
  };

  const value = {
    currentLanguage,
    changeLanguage,
    getCurrentLanguageInfo,
    availableLanguages: AVAILABLE_LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
